"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ascii_1 = require("./ascii");
const base64_1 = require("./base64");
const hex_1 = require("./hex");
const rfc3339_1 = require("./rfc3339");
const utf8_1 = require("./utf8");
/**
 * @deprecated All members of this namespacing class have been
 * converted to free functions in `@iov/encoding`
 */
class Encoding {
    /** @deprecated use free function toHex from `@iov/encoding` */
    static toHex(data) {
        return hex_1.toHex(data);
    }
    /** @deprecated use free function fromHex from `@iov/encoding` */
    static fromHex(hexstring) {
        return hex_1.fromHex(hexstring);
    }
    /** @deprecated use free function toBase64 from `@iov/encoding` */
    static toBase64(data) {
        return base64_1.toBase64(data);
    }
    /** @deprecated use free function fromBase64 from `@iov/encoding` */
    static fromBase64(base64String) {
        return base64_1.fromBase64(base64String);
    }
    /** @deprecated use free function toAscii from `@iov/encoding` */
    static toAscii(input) {
        return ascii_1.toAscii(input);
    }
    /** @deprecated use free function fromAscii from `@iov/encoding` */
    static fromAscii(data) {
        return ascii_1.fromAscii(data);
    }
    /** @deprecated use free function toUtf8 from `@iov/encoding` */
    static toUtf8(str) {
        return utf8_1.toUtf8(str);
    }
    /** @deprecated use free function fromUtf8 from `@iov/encoding` */
    static fromUtf8(data) {
        return utf8_1.fromUtf8(data);
    }
    /** @deprecated use free function fromRfc3339 from `@iov/encoding` */
    static fromRfc3339(str) {
        return rfc3339_1.fromRfc3339(str);
    }
    /** @deprecated use free function toRfc3339 from `@iov/encoding` */
    static toRfc3339(date) {
        return rfc3339_1.toRfc3339(date);
    }
}
exports.Encoding = Encoding;
//# sourceMappingURL=encoding.js.map